import {
    GET_HOURLY_FORECAST_BY_LATLON,
    GET_ZERO_HOUR_FORECAST,
    GET_FULL_HOURLY_FORECAST
} from '../actions/hourlyForecastActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    hourlyForecastIsRefreshing: false,
    zeroHourForecastIsRefreshing: false,
    fullHourlyForecastIsRefreshing: false
};

const mergeFullHourlyForecast = (fullHourlyForecast) => {
    if (!fullHourlyForecast || !Array.isArray(fullHourlyForecast)) {
        return [];
    }
    const latestValue = {};
    fullHourlyForecast.forEach((partData) => {
        partData?.hfp.forEach((value) => {
            if(partData?.fcu) {
                const newValue = {
                    ...value,
                    fcu: new Date(partData.fcu)
                };
                const existing = latestValue[newValue.fdus];
                if (!existing?.fcu || existing.fcu.getTime() < newValue.fcu.getTime()) {
                    latestValue[newValue.fdus] = newValue;
                }
            }
        });
    });
    return Object.values(latestValue);
};

export function hourlyForecast(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_HOURLY_FORECAST_BY_LATLON.pending:
        {
            return {
                ...state,
                hourlyForecastIsRefreshing: true
            };
        }
    
        case GET_HOURLY_FORECAST_BY_LATLON.fulfilled:
        {
            return {
                ...state,
                hourly: action.payload,
                lastError: undefined,
                hourlyForecastIsRefreshing: false
            };
        }
    
        case GET_HOURLY_FORECAST_BY_LATLON.rejected:
        {
            return {
                ...state,
                hourly: undefined,
                lastError: action.payload,
                hourlyForecastIsRefreshing: false
            };
        }
        
        case GET_ZERO_HOUR_FORECAST.pending:
        {
            return {
                ...state,
                zeroHourForecastIsRefreshing: true
            };
        }

        case GET_ZERO_HOUR_FORECAST.fulfilled:
        {
            return {
                ...state,
                zeroHourData: action.payload,
                zeroHourLastError: undefined,
                zeroHourForecastIsRefreshing: false
            };
        }

        case GET_ZERO_HOUR_FORECAST.rejected:
        {
            return {
                ...state,
                zeroHourData: undefined,
                zeroHourLastError: action.payload,
                zeroHourForecastIsRefreshing: false
            };
        }

        case GET_FULL_HOURLY_FORECAST.pending:
        {
            return {
                ...state,
                fullHourlyForecastIsRefreshing: true
            };
        }

        case GET_FULL_HOURLY_FORECAST.fulfilled:
        {
            return {
                ...state,
                fullHourlyData: mergeFullHourlyForecast(action.payload),
                fullHourlyLastError: undefined,
                fullHourlyForecastIsRefreshing: false
            };
        }

        case GET_FULL_HOURLY_FORECAST.rejected:
        {
            return {
                ...state,
                fullHourlyData: undefined,
                fullHourlyLastError: action.payload,
                fullHourlyForecastIsRefreshing: false
            };
        }
    }

    return state;
}
